import * as trace from 'owa-trace';
import hideToast from './hideToast';
import { MouseEvent } from 'react';

/**
 * Method invoked when a toast action button is clicked
 * @param event The click event captured by the component
 * @param numberOfRetriesAllowed This signifies number of times the retry should be done
 * @param onButtonClick primary action to be invoked when the button is clicked
 * @param onRetry primary action to be clicked on retry, the number of remaining retries is passed as a param to this
 */
export default async function onToastClicked(
    event?: MouseEvent<HTMLElement>,
    numberOfRetriesAllowed?: number,
    onButtonClick?: (event?: MouseEvent<HTMLElement>) => void | Promise<void>,
    onRetry?: (remainingRetries: number) => void
): Promise<void> {
    try {
        /**
         * First perform the click on the button
         * This onclick should throw an error on a failure
         * Based on the number of remaining retries, perform a retry
         */

        if (onButtonClick) {
            hideToast(); // close the toast if it is open in a success scenario
            /**
             * Wrapping onButtonClick to a promise, this is done
             * to avoid checking onButtonClick handler whether it returns
             * promise or not.
             */
            await Promise.resolve(onButtonClick(event));
        } else {
            throw new Error('No callback specified on click of event on toast:' + event);
        }
    } catch (error) {
        /*
         If we need to perform retries
         */

        // first hide any open toasts
        hideToast();

        if (numberOfRetriesAllowed && onRetry) {
            // Perform a retry, and also reduce the number of remaining retries
            onRetry(numberOfRetriesAllowed - 1);
        } else {
            trace.errorThatWillCauseAlert('All retries are done:' + error);
        }
    }
}
